import React from "react";
import Icon from "components/ui/Icon";
import { BodyLarge, Heading } from "components/ui/Text";
import { HelpMessage } from "components/form";
import UILabel from "components/ui/UILabel";
import { TaxReturnsWithAdvance } from "utils/hooks/useTaxReturnsWithAdvance";
import { formatAmount, getRefundAmountsFromIncomeTaxReturns } from "./utils";
import { REFUND_JURISDICTIONS } from "./constants";
import * as Styled from "./styled";

interface Props {
  taxReturnsWithAdvance: TaxReturnsWithAdvance;
}

const TaxReturns: React.FC<Props> = ({ taxReturnsWithAdvance }) => {
  const { taxReturns, refundAmount, hasEligibleReturns } =
    taxReturnsWithAdvance;
  const amounts = getRefundAmountsFromIncomeTaxReturns(taxReturns);

  return (
    <>
      {amounts && (
        <Styled.RefundAmounts>
          <Styled.RefundTotal>
            <UILabel.Micro wideCaps bold color="violet">
              Estimated Total Refund
            </UILabel.Micro>
            <Heading.H2 color="azure" tag="div">
              {formatAmount(refundAmount)}
            </Heading.H2>
          </Styled.RefundTotal>
          <Styled.RefundSubtotals>
            {REFUND_JURISDICTIONS.map((item) => (
              <Styled.Item key={item.valueKey}>
                <Styled.IconWrapper>
                  <Icon name={item.icon} color="violet" size="md" />
                </Styled.IconWrapper>
                <Styled.ItemContent>
                  <UILabel.Micro wideCaps bold color="violet">
                    {item.title}
                  </UILabel.Micro>
                  <BodyLarge tag="div" color="midnight">
                    {formatAmount(amounts[item.valueKey])}
                  </BodyLarge>
                </Styled.ItemContent>
              </Styled.Item>
            ))}
          </Styled.RefundSubtotals>
        </Styled.RefundAmounts>
      )}

      {hasEligibleReturns && (
        <HelpMessage>
          <UILabel.Medium color="violet">
            You'll be able to access a portion of your federal refund as soon as
            your tax return is accepted by the IRS.
          </UILabel.Medium>
        </HelpMessage>
      )}
    </>
  );
};

export default TaxReturns;
